import React from "react";
import { Link } from "@inertiajs/react";
import styled from "styled-components";
import { brand_orange_deep, outerContainerCss, narrowScreenMediaQuery } from "../constants/styles";

// Shared breadcrumb strip for course → curriculum → lesson pages. Each
// breadcrumb with a `url` becomes an Inertia `<Link>`; the last (current)
// crumb is rendered as a plain span.
function Breadcrumbs({ items, sticky = false }) {
  if (!items || items.length === 0) return null;
  return (
    <Strip $sticky={sticky} aria-label="Breadcrumbs">
      <Inner>
        <Trail>
          {items.map((item, i) => {
            const isLast = i === items.length - 1;
            return (
              <Crumb key={`${item.name}-${i}`}>
                {item.url && !isLast ? (
                  <CrumbLink href={item.url}>{item.name}</CrumbLink>
                ) : (
                  <CurrentCrumb aria-current={isLast ? "page" : undefined}>
                    {item.name}
                  </CurrentCrumb>
                )}
                {!isLast && <Separator aria-hidden="true">›</Separator>}
              </Crumb>
            );
          })}
        </Trail>
      </Inner>
    </Strip>
  );
}

export default React.memo(Breadcrumbs);

const Strip = styled.nav`
  background: #fff7ed;
  border-bottom: 1px solid #fed7aa;
  ${({ $sticky }) =>
    $sticky &&
    `
    position: sticky;
    top: 0;
    z-index: 30;
  `}

  [data-theme="dark"] & {
    background: rgba(216, 89, 7, 0.08);
    border-bottom-color: rgba(216, 89, 7, 0.24);
  }
`;

const Inner = styled.div`
  ${outerContainerCss}
  padding-top: 14px;
  padding-bottom: 14px;
`;

const Trail = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;

  @media ${narrowScreenMediaQuery} {
    font-size: 12px;
  }
`;

const Crumb = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const CrumbLink = styled(Link)`
  color: ${brand_orange_deep};
  font-weight: 600;
  text-decoration: none;
  transition: color 120ms ease;

  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${brand_orange_deep}; outline-offset: 2px; border-radius: 4px; }

  [data-theme="dark"] & { color: #fdba74; }
`;

const CurrentCrumb = styled.span`
  color: #1f2937;
  font-weight: 700;
  [data-theme="dark"] & { color: #f3f4f6; }
`;

const Separator = styled.span`
  color: #9ca3af;
`;
